import Vue from 'vue'
import { isCancel } from 'axios'

export default {
  namespaced: true,
  state: () => ({
    request: () => {},
    data: null,
  }),
  getters: {
    fetch: (state) => state.request,
    getPatientSummarySideBarInfo: (state) => state.data,
  },
  mutations: {
    setPatientSummarySideBarInfo: (state, data) => {
      state.data = data
    },
    setRequest(state, patientUuid) {
      state.request = Vue.$http('patient/fetchPatientSummarySideBarInfo', patientUuid)
    },
    cancelRequest: (state, cancellationReason) => {
      state.request.cancel(cancellationReason)
    },
  },
  actions: {
    openPatientSummarySideBar({ commit, dispatch, getters }, patientUuid) {
      const storedPatientUuid = getters.getPatientSummarySideBarInfo?.profile.user_uuid

      if (patientUuid !== storedPatientUuid) {
        dispatch('fetchData', patientUuid)
      }

      commit('general/toggleShowModal', { patientSummarySideBar: true }, { root: true })
    },
    async fetchData({ commit, getters }, patientUuid) {
      commit('setPatientSummarySideBarInfo', null)
      commit('setRequest', patientUuid)

      getters.fetch
        .then(({ data }) => {
          commit('setPatientSummarySideBarInfo', data)
        })
        .catch((error) => {
          if (isCancel(error)) return

          console.error('[patient-summary-side-bar] Error fetching patient summary.', error)
        })
    },
  },
}
